import { StressRiskLevel } from '../../abiotic-stress/domain/abiotic-stress.models';
import styled from 'styled-components';
import { getStressBackgroundColor, getStressTextColor } from './abiotic-stress-tag.utils';

interface StyledProps {
  $stressRiskLevel: StressRiskLevel;
}

export const Container = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  padding: 2px 6px;
  gap: 4px;
  border-radius: 4px;
  background-color: ${({ $stressRiskLevel }) => getStressBackgroundColor($stressRiskLevel)};
`;

export const Text = styled.div<StyledProps>`
  color: ${({ $stressRiskLevel }) => getStressTextColor($stressRiskLevel)};
  font-weight: 600;
  font-size: 12px;
  font-family: 'Noto Sans';
  line-height: 22px;
  text-transform: ${({ $stressRiskLevel }) => ($stressRiskLevel === StressRiskLevel.NONE ? 'uppercase' : 'none')};
`;
